import { render, staticRenderFns } from "./Proveider.vue?vue&type=template&id=3bdcc6f4&scoped=true"
import script from "./Proveider.vue?vue&type=script&lang=js"
export * from "./Proveider.vue?vue&type=script&lang=js"
import style0 from "./Proveider.vue?vue&type=style&index=0&id=3bdcc6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdcc6f4",
  null
  
)

export default component.exports